import React from 'react'
import './styles.css';

const InputField = ({name, label, value, onChange}) => {
  return (
    <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
        <label htmlFor={name}>{label}</label>
        <input className='input-field' id={name} name={name} type='text' value={value} onChange={onChange} />
    </div>
  )
}

export default InputField